import { render, staticRenderFns } from "./SpouseMap.vue?vue&type=template&id=1dda4dd2&scoped=true&"
import script from "./SpouseMap.vue?vue&type=script&lang=js&"
export * from "./SpouseMap.vue?vue&type=script&lang=js&"
import style0 from "./SpouseMap.vue?vue&type=style&index=0&id=1dda4dd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dda4dd2",
  null
  
)

export default component.exports